import React, { useState, useEffect, ReactElement, Fragment, cloneElement } from "react";
import { View, StyleSheet, Text } from 'react-native';
import Modal from "react-modal";

import { ReactComponent as CloseButtonImg } from "../../../img/btn-close-white.svg";
import { ReactComponent as InfoMessageImg } from "../../../img/ico-msg-info.svg";

import { ReactComponent as CheckedNormalImg } from "../../../img/ico-prefix-btn-checked.svg";
import { ReactComponent as CheckedHoverImg } from "../../../img/ico-prefix-btn-checked-hover.svg";
import { ReactComponent as CheckedDisableImg } from "../../../img/ico-prefix-btn-checked-disable.svg";

import { ReactComponent as VmNormalImg } from "../../../img/ico-prefix-add-pc.svg";
import { ReactComponent as VmoverImg } from "../../../img/ico-prefix-add-pc-hover.svg";
import { ReactComponent as VmDisableImg } from "../../../img/ico-prefix-add-pc-disable.svg";

import { ReactComponent as DiskNormalImg } from "../../../img/ico-prefix-add-disk.svg";
import { ReactComponent as DiskHoverImg } from "../../../img/ico-prefix-add-disk-hover.svg";
import { ReactComponent as DiskDisableImg } from "../../../img/ico-prefix-add-disk-disable.svg";

import { FONT } from "../../../value/staticValues";

import { CustomConfirmBtn } from "../CustomConfirmBtn";
import { CustomCancelBtn } from "../CustomCancelBtn";
import { CustomPrevBtn } from "../CustomPrevBtn";

import { useTranslation } from "react-i18next";
import { CustomDeleteBtn } from "../CustomDeleteBtn";

export interface ApiResponseReturnType {
    successYn: boolean;
    reason?: string;
	type?: string;
	completeYn?: boolean;
}

export interface SlideModalFooterButtonType {
	index: number;
	prevButtonYn: boolean;
	deleteButtonYn?: boolean;
	cancelButtonYn: boolean;
	confirmButtonText: string;
}

export interface SlideModalContentType {
	openYn: boolean;
	title: string;
	stepCount: number;
	type: string;
	footerButtons: SlideModalFooterButtonType[];
	innerComponent: ReactElement;
	args?;
	resultCb?: Function;
}

interface SlideModalProps {
	showLoadingCb: Function;
	showSlideModalCb: Function;
	showEditPopupModalCb: Function;
	showPopupModalCb: Function;
	content: SlideModalContentType;
}

function SlideModal(props: SlideModalProps){
    const { t } = useTranslation();

	const [slideIndex, setSlideIndex] = useState(-1);
	const [confirmButtonWidth, setConfirmButtonWidth] = useState(48);
	const [inforMessage, setInfoMessage] = useState("");
	const [clickedConfirmYn, setClickedConfirmYn] = useState(false);
	const [clickedCompleteYn, setClickedCompleteYn] = useState(false);
	const [clickedActionYn, setClickedActionYn] = useState(false);
	const [clickedRejectYn, setClickedRejectYn] = useState(false);
	const [clickedCommentYn, setClickedCommentYn] = useState(false);
	const [lockActionYn, setLockActionYn] = useState(false);
	const [lockCompleteYn, setLockCompleteYn] = useState(false);
	const [changeDetailYn, setChangeDetailYn] = useState(false);

	useEffect(() => {
		if(props.content.stepCount > 0) {
			setSlideIndex(0);
		} else {
			//init
			setSlideIndex(-1);
			
		}
		setConfirmButtonWidth(48);
		setInfoMessage("");
		setClickedConfirmYn(false);
		setClickedActionYn(false);
		setClickedRejectYn(false);
		setClickedCommentYn(false);
		setClickedCompleteYn(false);
		setChangeDetailYn(false);
	}, [props.content.stepCount]);

	useEffect(() => {
		if(slideIndex >= 0) {
			setConfirmButtonWidth(props.content.footerButtons[slideIndex].confirmButtonText.length * 6 + 38);
		}
	}, [slideIndex]);


	function prevModal() {
		if(slideIndex !== 0) {
			setSlideIndex(slideIndex - 1);
		}
		
	}
	function forceCloseModal() {
		if(props.content.type && changeDetailYn) {
			
			if(props.content.resultCb) {
				props.content.resultCb({refreshYn: true});
			}
		}
		props.showSlideModalCb(SlideModal.defaultProps);
	}
	function closeModal() {
		if(!lockActionYn) {
			if(props.content.args?.serviceRequestId && props.content.args?.serviceRequestTypeCode && props.showSlideModalCb){
				props.showSlideModalCb({openYn: true, type:props.content.args?.serviceRequestTypeCode, resultCb: props.content.resultCb, args: {
					serviceRequestId: props.content.args?.serviceRequestId, allocateYn: false
				}});
			} else {
				props.showSlideModalCb(SlideModal.defaultProps);
			}
		}
	}
	
	function nextModal() {
		if(clickedConfirmYn) {
			return ;
		}
		if(slideIndex === props.content.stepCount - 1) {
			props.showLoadingCb(true);
		}
		setClickedConfirmYn(true);
	}

	function resultModal(result:ApiResponseReturnType, closeYn:boolean) {
		if(clickedConfirmYn)
			props.showLoadingCb(false);


		if(result.successYn) {
			if(slideIndex < props.content.stepCount - 1) {
				setSlideIndex(slideIndex + 1);
				setClickedConfirmYn(false);
				return ;
			}
			
		}
		if(clickedConfirmYn && slideIndex === props.content.stepCount - 1 && props.content.resultCb) {
			props.content.resultCb(result);
		}

		setClickedConfirmYn(false);
		setClickedActionYn(false);
		setClickedRejectYn(false);
		setClickedCommentYn(false);
		setClickedCompleteYn(false);
		setChangeDetailYn(false);

		if(closeYn) {
			forceCloseModal();
		}
	}

	

	function clickComment() {
		setClickedCommentYn(true);
	}

	function clickReject() {
		setClickedRejectYn(true);
	}

	function clickAction() {
		setClickedActionYn(true);
	}

	function clickComplete() {
		setClickedCompleteYn(true);
	}


	function closeComment() {
		setClickedCommentYn(false);
	}

	function closeAction() {
		setClickedActionYn(false);
	}

	function closeComplete() {
		setClickedCompleteYn(false);
	}

	function closeReject() {
		setClickedRejectYn(false);
	}

	function showMessage(message) {
		setInfoMessage(message);
	}


	function showLoading(activeYn) {
		props.showLoadingCb(activeYn);
	}

	

	function lockAction(lockYn) {
		setLockActionYn(lockYn);
	}
	
	
	function lockComplete(lockYn) {
		setLockCompleteYn(lockYn);
	}
    return (
			<Modal
                isOpen={props.content.openYn}
                style={modalClass}
                contentLabel={"sideModal"}
                ariaHideApp={false}
			>
				{
					props.content.openYn?
					<View style={style.topContainer}>
						<View style={style.titleContainer}>
							<Text style={style.titleTextValue}>
                                {props.content.title}
                            </Text>
							<CloseButtonImg
                                onClick={() => {forceCloseModal();}}
                                style={{
                                    width: 28, height: 28,
                                    marginLeft: "auto", marginRight: "40px",
                                    boxShadow: "none",
                                    cursor: "pointer",
                                }}
                            />
						</View>
						<View style={style.contentContainer}>
							{
								slideIndex >= 0 ?
									!props.content.type ?
										cloneElement(props.content.innerComponent, {
                                            showMessageCb:showMessage,
                                            showLoadingCb:showLoading, 
                                            showSlideModalCb:props.showSlideModalCb, 
                                            stepCount:props.content.stepCount, 
                                            stepIndex:slideIndex, 
                                            clickedConfirmYn:clickedConfirmYn, 
                                            resultCb:resultModal, 
                                            lockActionCb:lockAction, 
                                            args: props.content.args
                                        })
									: 
										cloneElement(props.content.innerComponent, {
                                            showMessageCb:showMessage, 
                                            showLoadingCb:showLoading, 
                                            showEditPopupModalCb:props.showEditPopupModalCb, 
                                            showSlideModalCb:props.showSlideModalCb, 
                                            showPopupModalCb:props.showPopupModalCb, 
                                            stepCount:props.content.stepCount, 
                                            stepIndex:slideIndex, 
                                            clickedConfirmYn:clickedConfirmYn, 
                                            clickedActionYn:clickedActionYn, 
                                            clickedCompleteYn:clickedCompleteYn, 
                                            clickedRejectYn:clickedRejectYn, 
                                            clickedCommentYn:clickedCommentYn, 
                                            resultCb:props.content.resultCb, 
                                            lockActionCb:lockAction, 
                                            lockCompleteCb:lockComplete, 
                                            closeCompleteCb:closeComplete, 
                                            closeActionCb:closeAction, 
                                            closeRejectCb:closeReject, 
                                            closeCommentCb:closeComment, 
                                            changeDetailCb: setChangeDetailYn, 
                                            args: props.content.args
                                        })
								: null
							}
						</View>
						<View style={style.infoMessageContainer}>
							{
								inforMessage ? 
                                <Fragment>
                                    <InfoMessageImg />
                                    <Text style={style.inforMessageText}>
                                        {inforMessage}
                                    </Text>
                                </Fragment> 
                                : null
							}
						</View>
						{
							!props.content.type ?
                        <View style={style.buttonContainer}>
                            <View style={style.prevButtonContainer}>
                                {
                                    slideIndex >= 0 && props.content.footerButtons[slideIndex].prevButtonYn ? 
                                        <CustomPrevBtn
                                            text={t("PREV_STEP_TEXT")} 
                                            onPress={prevModal} 
                                            disabled={lockActionYn} 
                                            size={{width: 103, height: 36}}
                                        /> 
                                        : null
                                }
                            </View>
                            <View style={style.prevButtonContainer}>
                                {
                                    slideIndex >= 0 && props.content.footerButtons[slideIndex].deleteButtonYn ? 
                                        <CustomDeleteBtn
                                            text={t("DELETE_TEXT")} 
                                            onPress={prevModal} 
                                            disabled={lockActionYn} 
                                            size={{width: 70, height: 36}}
                                        /> 
                                        : null
                                }
                            </View>
                            <View style={style.cancelButtonContainer}>
                                {
                                    //취소 버튼 추가
                                    slideIndex >= 0 && props.content.footerButtons[slideIndex].cancelButtonYn ?
                                        <CustomCancelBtn
                                            text={t("CANCEL_TEXT")} 
                                            onPress={closeModal} 
                                            disabled={lockActionYn} 
                                            size={{width: 48, height: 36}}
                                        />
                                        : null
                                }
                            </View>
                            <View style={style.confirmButtonContainer}>
                                {
                                    slideIndex >= 0 ? 
                                        <CustomConfirmBtn 
                                            text={props.content.footerButtons[slideIndex].confirmButtonText} 
                                            onPress={nextModal} 
                                            disabled={clickedConfirmYn || lockActionYn} 
                                            size={{width: confirmButtonWidth, height: 10}} 
                                        />
                                        : null
                                }
                            </View>
                        </View>
						:
						<View style={style.buttonContainer}>
							<View style={style.commentButtonContainer}>
								<CustomConfirmBtn
                                    text={t("COMMENT_TEXT")} 
                                    onPress={clickComment} 
                                    disabled={true} 
                                    size={{width: 48, height: 10}}
                                />
							</View>
							<View style={style.closeButtonContainer}>
								<CustomCancelBtn
                                    text={t("CLOSE_TEXT")} 
                                    onPress={forceCloseModal} 
                                    disabled={true} 
                                    size={{width: 48, height: 10}}
                                />
							</View>
							<View style={style.rejectButtonContainer}>
								<CustomDeleteBtn
                                    text={t("REJECT_TEXT")} 
                                    onPress={clickReject}
                                    disabled={!lockActionYn || !lockCompleteYn} 
                                    size={{width: 48, height: 10}}
                                />
							</View>
							{
								props.content.type === "VMEXT" ||  props.content.type === "DISKEXT" || props.content.type === "VMPLEXT" || props.content.type === "DISKPLEXT" || props.content.type === "TPLEXT" ||
								props.content.type === "VMOPT" ||  props.content.type === "VMPLOPT"?
								null:
								<View style={style.completeButtonContainer}>
									<CustomConfirmBtn 
                                        text={t("PROCESS_COMPLETE_TEXT")} 
                                        onPress={clickComplete} 
                                        disabled={!lockCompleteYn} 
                                        size={{width: 77, height: 10}}
                                    />
								</View>

							}
						</View>
						}
					</View>
					:
					null
				}
			</Modal>


    )
}

SlideModal.defaultProps = {
	content: {
		openYn: false,
		title: "",
		type: "",
		stepCount: -1,
		footerButtons: [],
		innerComponent: <View></View>,
	}
};

const style = StyleSheet.create({
	topContainer: {
		height: "100%",
		paddingHorizontal: 40,
		paddingVertical: 36,
		overflowY: "scroll"
	},
	titleContainer: {
		marginBottom: 24,
		flexDirection: "row",
		alignItems: "center"
	},
	titleTextValue: {
		fontFamily: FONT.MEDIUM,
		fontSize: 18,
		fontWeight: "500",
		lineHeight: 1,
		color: "#333"
	},
	contentContainer: {
		zIndex: 5,
		minHeight: 840,
	},
	infoMessageContainer: {
		marginTop: "auto",
		paddingLeft: 20,
		paddingRight: 20,
		height: 44,
		flexDirection: "row",
		overflow: "hidden"
	},
	inforMessageText: {
		width: 640,
		marginTop: 2,
		marginLeft: 8,
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#323ebd"
	},
	buttonContainer: {
		paddingTop: 20,
		height: 64,
		borderTopWidth: 1,
		borderTopColor: "#eee",
		flexDirection: "row"
	},
	prevButtonContainer: {
		marginLeft: 10,
	},
	cancelButtonContainer: {
		marginLeft: "auto",
		marginRight: 10,

	},
	confirmButtonContainer: {
		marginRight: 10,
	},
	commentButtonContainer: {

	},
	closeButtonContainer: {
		marginLeft: "auto",
	},
	rejectButtonContainer: {
		marginLeft: 10
	},
	actionButtonContainer: {
		marginLeft: 10
	},
	completeButtonContainer: {
		marginLeft: 10
	}
});

const className = {
	titleCloseButtonImg: {
		width: "28px",
		height: "28px",
		marginLeft: "auto",
		marginRight: "40px",
		boxShadow: "none",
		cursor: "pointer"
	},
	titleCloseButtonImgHover: {
		width: "28px",
		height: "28px",
		marginLeft: "auto",
		marginRight: "40px",
		boxShadow: "none",
		cursor: "pointer"
	}
}

const modalClass = {
	content: {
        width: 800,
		height: "100%",
		marginLeft: "auto",
		padding: 0,
		backgroundColor: "#fff",
		borderRadius: "20px  0 0 20px",
		boxShadow: "0 10px 12px 0 rgba(0, 0, 0, 0.4)",
		border: "solid 1px #e5e9ec",
        zIndex: 15,
		inset: "0 0 auto"
	},
    overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.6)"
	},
};

export default SlideModal;